<section class="feedback">
    <div class="feedback-title">
        <div>Свяжитесь с нами</div>
        <div class="btn-dialog-close" (click)="attemptClose()">
            <img src="./assets/img/svg/cross.svg" alt="close" />
        </div>
    </div>
    <div class="loading-group">
        <div class="loading" *ngIf="loading">
            <loader type="page"> </loader>
            <span>Отправляем обращение...</span>
        </div>

        <!-- Контейнер основного контента, который сохраняет размер -->
        <div class="form-container" *ngIf="!loading">
            <!-- Форма -->
            <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
                <!-- Почта отправителя -->
                <div class="custom-form-field">
                    <input
                        id="email"
                        type="email"
                        formControlName="email"
                        placeholder="Email*"
                    />
                </div>

                <!-- Тема сообщения -->
                <div class="custom-form-field">
                    <div
                        #subjectDropdown
                        class="custom-select"
                        (click)="toggleSubjectDropdown()"
                    >
                        <span class="selected-option">{{
                            selectedSubject?.title || "Выберите тип обращения*"
                        }}</span>
                        <img
                            src="./assets/img/svg/account/arrow.svg"
                            class="dropdown-arrow"
                            [class.open]="isSubjectOpen"
                        />

                        <div class="dropdown-list" *ngIf="isSubjectOpen">
                            <div
                                class="dropdown-item"
                                *ngFor="let subject of subjectOptions"
                                (click)="selectSubject(subject, $event)"
                            >
                                {{ subject.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Подтема сообщения -->
                <div
                    class="custom-form-field"
                    *ngIf="
                        selectedSubject?.subthemes &&
                        selectedSubject.subthemes.length > 0
                    "
                >
                    <div
                        #subsubjectDropdown
                        class="custom-select"
                        (click)="toggleSubsubjectDropdown()"
                    >
                        <span class="selected-option">{{
                            selectedSubsubject || "Уточните тему"
                        }}</span>
                        <img
                            src="./assets/img/svg/account/arrow.svg"
                            class="dropdown-arrow"
                            [class.open]="isSubsubjectOpen"
                        />

                        <div class="dropdown-list" *ngIf="isSubsubjectOpen">
                            <div
                                class="dropdown-item"
                                *ngFor="
                                    let subsubject of selectedSubject.subthemes
                                "
                                (click)="selectSubsubject(subsubject, $event)"
                            >
                                {{ subsubject }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Сообщение -->
                <div class="custom-form-field">
                    <textarea
                        id="message"
                        formControlName="message"
                        maxlength="1000"
                        placeholder="Сообщение*"
                        style="resize: none"
                    ></textarea>
                </div>

                <!-- Кнопка отправки -->
                <button
                    mat-raised-button
                    type="submit"
                    [disabled]="form.invalid"
                    class="btn"
                >
                    <ng-container *ngIf="!loading">Отправить</ng-container>
                    <ng-container *ngIf="loading">
                        <div class="btn-loader"></div>
                    </ng-container>
                </button>
            </form>

            <!-- Диалог подтверждения поверх формы -->
            <div class="confirmation-overlay" *ngIf="showConfirmation">
                <div class="confirmation-dialog">
                    <div class="confirmation-header">
                        <h3>Подтвердите закрытие</h3>
                    </div>
                    <div class="confirmation-body">
                        <p>
                            Вы уверены, что хотите закрыть форму обратной связи?
                            Все несохраненные данные будут потеряны.
                        </p>
                    </div>
                    <div class="confirmation-footer">
                        <button
                            class="btn btn-secondary"
                            (click)="cancelClose()"
                        >
                            Вернуться
                        </button>
                        <button
                            class="btn btn-primary"
                            (click)="confirmClose()"
                        >
                            Да, закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
